export default {
	id: '',
	messageType: 'chat',
	type: 'conversationMessage',
	recipients: null,
	message: '',
	createdAt: null,
	tags: []
}
